import { format as formatTZ } from "date-fns-tz";

// 共通: ビルド環境
export const appEnv = {
  // 開発環境
  dev: "dev",
  // 検証環境
  stgsecond: "stgsecond",
  // 本番環境
  prodsecond: "prodsecond",
};

// 共通: ログ出力(タイムスタンプ付き)
export const log = (message, ...optionalParams) => {
  // 本番環境の場合は無効化
  if (process.env.REACT_APP_ENV !== appEnv.prodsecond) {
    let str = `${formatTZ(new Date(), "yyyy-MM-dd HH:mm:ss", {
      timeZone: "Asia/Tokyo",
    })}:`;
    if (typeof message === "string") {
      str = `${str} ${message}`;
      console.log(str, ...optionalParams);
    } else {
      console.log(str, message, ...optionalParams);
    }
  }
};

// 共通: スリープ単位
export const sleepUnit = {
  // 時
  hour: (value) => value * 1000 * 60 * 60,
  // 分
  minutes: (value) => value * 1000 * 60,
  // 秒
  seconds: (value) => value * 1000,
  // ミリ秒
  milliseconds: (value) => value,
};

// 共通: スリープ処理
export const sleep = (value) =>
  new Promise((resolve) => setTimeout(resolve, value));

// 共通: アイコン設定
export const iconColor = "inherit";
export const iconSize = "large";
export const iconEdge = "end";

// 共通: 色
export const colorType = {
  // 黒色
  black: "#000000",
  // 灰色
  gray: "#808080",
  // 藍色
  indigo: "#002060",
  // 深緑色
  deepGreen: "#385723",
  // 橙色
  orange: "#ed7d31",
  // 水色
  lightBlue: "#5b9bd5",
  // 勿忘草色
  myosotis: "#89c3eb",
  // 桃色
  pink: "#ff00ff",
};

// 共通: 管理系画面で非表示にする工番一覧(開発者向け)
export const hiddenPressNo = [
  // 一時保存フォルダ
  "00000",
  // Gateway-Log
  "develop",
];

// 共通: ソート定義
export const sortRule = {
  asc: [1, -1],
  desc: [-1, 1],
};

// 共通: ソート種別
export const sortType = {
  // 昇順
  asc: "asc",
  // 降順
  desc: "desc",
};

// File: 改行コード
export const textEndType = {
  crlf: "\r\n",
  cr: "\r",
  lf: "\n",
};

// File: 区切り文字
export const textDelimiter = ",";

// File: グラフ線図データCSV
export const curveCsvName = (pressNo) => `CURVE_${pressNo}.csv`;

// File: グラフ線図データCSV: 列定義
export const curveCsvColumn = {
  // 線種
  type: 0,
  // X座標(偏心量)
  x: 1,
  // Y座標(合計荷重)
  y: 2,
};

// DB: Key定義
export const dbKey = {
  // 工番(製造番号)
  pressNo: "serialNumber",
  // 拠点名
  label: "label",
  // プレス種別
  pressType: "pressType",
  // グラフ線図登録状況
  uploadCurve: "uploadCurve",
};

// DB: グラフ線図登録状況
export const uploadCurveStatus = {
  success: { value: "SUCCESS", label: "登録済み" },
  error: { value: "ERROR", label: "CSV不適合" },
  none: { value: "NONE", label: "未登録" },
};

// DB: グラフ線図登録状況: getter for label
export const getUploadCurveLabel = (uploadCurve) => {
  let label = "-";
  const statusKeys = Object.keys(uploadCurveStatus);

  statusKeys.some((key) => {
    if (uploadCurveStatus[key].value === uploadCurve) {
      label = uploadCurveStatus[key].label;
      return true;
    }
    return false;
  });

  return label;
};

// Graph: グラフ種別
export const graphType = {
  // 左右方向
  lr: "lr",
  // 前後方向
  fb: "fb",
};

// Graph: 補助線(Key & 凡例初期名称)
export const curveInfo = {
  // 左右方向
  lr: {
    // 許容偏心荷重曲線
    load: { key: "LR-LOAD", legend: "ECCENTRIC ALLOWABLE LOAD" },
    // 補助曲線1
    curve1: { key: "LR-CURVE1", legend: "JIS 1st GRADE" },
    // 補助曲線2
    curve2: { key: "LR-CURVE2", legend: "JIS 2nd GRADE" },
    // 補助曲線3
    curve3: { key: "LR-CURVE3", legend: "JIS 3rd GRADE" },
    // 補助曲線4
    curve4: { key: "LR-CURVE4", legend: "RECOMMENDED LOAD1" },
    // 補助曲線5
    curve5: { key: "LR-CURVE5", legend: "RECOMMENDED LOAD2" },
    // 補助縦線1
    line1: { key: "LR-LINE1", legend: "" },
    // 補助縦線2
    line2: { key: "LR-LINE2", legend: "" },
    // 補助縦線3
    line3: { key: "LR-LINE3", legend: "" },
    // 補助縦線4
    line4: { key: "LR-LINE4", legend: "" },
  },
  // 前後方向
  fb: {
    // 許容偏心荷重曲線
    load: { key: "FB-LOAD", legend: "ECCENTRIC ALLOWABLE LOAD" },
    // 補助曲線1
    curve1: { key: "FB-CURVE1", legend: "JIS 1st GRADE" },
    // 補助曲線2
    curve2: { key: "FB-CURVE2", legend: "JIS 2nd GRADE" },
    // 補助曲線3
    curve3: { key: "FB-CURVE3", legend: "JIS 3rd GRADE" },
    // 補助曲線4
    curve4: { key: "FB-CURVE4", legend: "RECOMMENDED LOAD1" },
    // 補助曲線5
    curve5: { key: "FB-CURVE5", legend: "RECOMMENDED LOAD2" },
    // 補助縦線1
    line1: { key: "FB-LINE1", legend: "" },
    // 補助縦線2
    line2: { key: "FB-LINE2", legend: "" },
    // 補助縦線3
    line3: { key: "FB-LINE3", legend: "" },
    // 補助縦線4
    line4: { key: "FB-LINE4", legend: "" },
  },
};

// Graph: 補助線: getter for group
export const getCurveInfoGroup = (groupKey) => {
  let group = {};
  const groupKeys = Object.keys(curveInfo);

  groupKeys.some((key) => {
    if (key === groupKey) {
      group = curveInfo[key];
      return true;
    }
    return false;
  });

  return group;
};

// Graph: 凡例: アイコン種別
export const legendIconType = {
  // 線
  line: "plainline",
  // 四角
  square: "square",
};

// Graph: 凡例: アイコン: オプション種別
export const legendOptionType = {
  // 実線
  solid: { strokeDasharray: "0 0" },
  // 破線
  dashed: { strokeDasharray: "10 8" },
};

// Graph: 凡例
export const legendInfo = [
  {
    key: curveInfo.lr.load.key,
    icon: legendIconType.line,
    color: colorType.indigo,
    option: legendOptionType.solid,
  },
  {
    key: curveInfo.lr.curve1.key,
    icon: legendIconType.line,
    color: colorType.deepGreen,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.curve2.key,
    icon: legendIconType.line,
    color: colorType.orange,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.curve3.key,
    icon: legendIconType.line,
    color: colorType.lightBlue,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.curve4.key,
    icon: legendIconType.line,
    color: colorType.pink,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.curve5.key,
    icon: legendIconType.line,
    color: colorType.gray,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.line1.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.line2.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.line3.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.lr.line4.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },

  {
    key: curveInfo.fb.load.key,
    icon: legendIconType.line,
    color: colorType.indigo,
    option: legendOptionType.solid,
  },
  {
    key: curveInfo.fb.curve1.key,
    icon: legendIconType.line,
    color: colorType.deepGreen,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.curve2.key,
    icon: legendIconType.line,
    color: colorType.orange,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.curve3.key,
    icon: legendIconType.line,
    color: colorType.lightBlue,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.curve4.key,
    icon: legendIconType.line,
    color: colorType.pink,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.curve5.key,
    icon: legendIconType.line,
    color: colorType.gray,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.line1.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.line2.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.line3.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },
  {
    key: curveInfo.fb.line4.key,
    icon: legendIconType.line,
    color: colorType.black,
    option: legendOptionType.dashed,
  },
];

// Graph: 凡例: getter for key
export const getLegendInfo = (key) => {
  let info;

  legendInfo.some((legend) => {
    if (legend.key === key) {
      info = legend;
      return true;
    }
    return false;
  });

  return info;
};
